import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import CryptoJS from "crypto-js";
// @material-ui/icons
import InputAdornment from "@material-ui/core/InputAdornment";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import API from "@aws-amplify/api";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { Auth } from "aws-amplify";
import cmplogo from "assets/img/cmp-logo.svg";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import LoadingOverlay from "react-loading-overlay";
import decode from "jwt-decode";
import Cookies from "universal-cookie";
import handlePowerBiLogin from "../../util/powerBi/handlePowerBiLogin";
import { saveData } from "../../util/dataCaching/cmpStorageManager";
const cookies = new Cookies();

let apiName = process.env.REACT_APP_AMPLIFY_API;

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      isActive: false,
      cardAnimaton: "cardHidden",
      email: "",
      password: "",
      registerEmailState: "",
      registerPasswordState: "",
      errorMsg: "",
      loggedIn: false,
      tr: false,
      message: "",
      color: "success",
    };
    //this.refreshToken = this.refreshToken.bind(this);
  }
  
  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value,
    });

    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ registerEmailState: "success" });
        } else {
          this.setState({ registerEmailState: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 8)) {
          this.setState({ registerPasswordState: "success" });
        } else {
          this.setState({ registerPasswordState: "error" });
        }
        break;
      default:
    }
  }

  // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  registerClick() {
    if (this.state.registerEmailState === "") {
      this.setState({ registerEmailState: "error" });
    }
    if (this.state.registerPasswordState === "") {
      this.setState({ registerPasswordState: "error" });
    }
  }
  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        6000
      );
    }
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    this.registerClick();
    if (this.state.email !== "" && this.state.password !== "") {
      try {
        let password = this.state.password;
        let email = this.state.email;
        Auth.signIn(email, password)
          .then((data) => {
            //

            //
            if (data["username"]) {
              cookies.remove("Qlik-Ticket-CMP", {
                path: "/",
                domain: ".cmp.io",
              });
              cookies.remove("X-Qlik-Session-CMP", {
                path: "/",
                domain: ".cmp.io",
              });
              cookies.remove("X-Qlik-Session", {
                path: "/",
                domain: ".cmp.io",
              });
              cookies.remove("X-Qlik-Session", {
                path: "/",
                domain: process.env.REACT_APP_QLIKURL,
                httpOnly: true,
                secure: true,
              });

              //
              this.setState({ message: "You have successfully logged in." });
              this.setState({ isActive: true });
              this.setState({ color: "success" });
              this.showNotification("tr");

              Auth.currentSession().then((response) => {
                // Save Auth Token Encrypted
                localStorage.setItem(
                  "jwtToken",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(response.idToken.jwtToken),
                    process.env.REACT_APP_PASS
                  ).toString()
                );

                let userToken = response.idToken.jwtToken;
                //localStorage.setItem("refreshToken", response.Token);
                const decoded = decode(userToken);
                localStorage.setItem(
                  "given_name",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(decoded.given_name),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
                localStorage.setItem(
                  "family_name",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(decoded.family_name),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
                localStorage.setItem(
                  "email",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(decoded.email),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
                localStorage.setItem(
                  "userId",
                  CryptoJS.AES.encrypt(
                    JSON.stringify(decoded.sub),
                    process.env.REACT_APP_PASS
                  ).toString()
                );
                let path = "/users";
                let custHeaders = {
                  headers: {
                    userId: decoded.sub,
                  },
                };
                //Gets the user Id from the localstorage and fectches the user record from cmp-users
                API.get(apiName, path, custHeaders)
                  .then((response) => {                    
                    let groupsInit = {
                      headers: {
                        securityGroup: response[0]["groupId"],
                      },
                    };
                    localStorage.setItem(
                      "clientId",
                      CryptoJS.AES.encrypt(
                        JSON.stringify(response[0]["clientId"]),
                        process.env.REACT_APP_PASS
                      ).toString()
                    );
                    // Set the Group Id in the localStorage to know whether to show Display Parameters button for BajaFresh/ColdStone.
                    localStorage.setItem(
                      "groupId",
                      CryptoJS.AES.encrypt(
                        JSON.stringify(response[0]["groupId"]),
                        process.env.REACT_APP_PASS
                      ).toString()
                    );
                    let groupPath = "/groups";
                    API.get(apiName, groupPath, groupsInit)
                      .then((response) => {
                        let eachGroupClient = response[0]["clients"];
                        let genericLicensedModules =
                          response[0]["licensedModules"];
                        let initialclientLicensedModules = eachGroupClient.filter(
                          (x) =>
                            x.clientId ==
                            JSON.parse(
                              CryptoJS.AES.decrypt(
                                localStorage.getItem("clientId"),
                                process.env.REACT_APP_PASS
                              ).toString(CryptoJS.enc.Utf8)
                            )
                        );
                        let initialcombinedModules = genericLicensedModules.concat(
                          initialclientLicensedModules[0]["licensedModules"]
                        );
                        localStorage.setItem(
                          "licensedModules",
                          CryptoJS.AES.encrypt(
                            JSON.stringify(
                              initialcombinedModules.filter(
                                (item, pos) =>
                                  initialcombinedModules.indexOf(item) === pos
                              )
                            ),
                            process.env.REACT_APP_PASS
                          ).toString()
                        );
                        let cpath = "/clients";
                        let authClients = [];
                        API.get(apiName, cpath)
                          .then(async (response) => {
                            let tempArrayOfClientIds = [];
                            for (let eachclient in response) {
                              if ("concepts" in response[eachclient]) {
                                for (let eachconcept in response[eachclient][
                                  "concepts"
                                ]) {
                                  if (
                                    response[eachclient]["concepts"][
                                      eachconcept
                                    ]["settings"]["cmp"]["clientId"] ==
                                    JSON.parse(
                                      CryptoJS.AES.decrypt(
                                        localStorage.getItem("clientId"),
                                        process.env.REACT_APP_PASS
                                      ).toString(CryptoJS.enc.Utf8)
                                    )
                                  ) {
                                    localStorage.setItem(
                                      "model",
                                      CryptoJS.AES.encrypt(
                                        JSON.stringify(
                                          response[eachclient]["settings"][
                                            "cmp"
                                          ]["model"]
                                        ),
                                        process.env.REACT_APP_PASS
                                      ).toString()
                                    );
                                  }
                                  response[eachclient]["concepts"][eachconcept][
                                    "model"
                                  ] =
                                    response[eachclient]["settings"]["cmp"][
                                      "model"
                                    ];
                                  response[eachclient]["concepts"][eachconcept][
                                    "parentName"
                                  ] = response[eachclient]["name"];
                                  response[eachclient]["concepts"][eachconcept][
                                    "activeLocations"
                                  ] = response[eachclient]["activeLocations"];
                                  // Added the suppressionCustId parameter to use in the query to suppress the cust id for Lou Malnatis client.
                                  response[eachclient]["concepts"][eachconcept][
                                    "suppressionCustId"
                                  ] = response[eachclient]["suppressionCustId"];
                                  tempArrayOfClientIds.push(
                                    response[eachclient]["concepts"][
                                      eachconcept
                                    ]
                                  );
                                }
                              }
                            }
                            for (let eachC in tempArrayOfClientIds) {
                              let clientLicensedModules = eachGroupClient.filter(
                                (x) =>
                                  x.clientId ==
                                  tempArrayOfClientIds[eachC]["settings"][
                                    "cmp"
                                  ]["clientId"]
                              );
                              if (clientLicensedModules.length == 1) {
                                let combinedModules = genericLicensedModules.concat(
                                  clientLicensedModules[0]["licensedModules"]
                                );
                                tempArrayOfClientIds[eachC][
                                  "licensedModules"
                                ] = combinedModules.filter(
                                  (item, pos) =>
                                    combinedModules.indexOf(item) === pos
                                );
                                authClients.push(tempArrayOfClientIds[eachC]);
                              }
                            }
                            localStorage.setItem(
                              "groupDetails",
                              CryptoJS.AES.encrypt(
                                JSON.stringify(authClients),
                                process.env.REACT_APP_PASS
                              ).toString()
                            );
                            let dropDownObj = [];
                            for (let eachc in authClients) {
                              let newObj = {};
                              if (authClients[eachc]["active"] == true) {
                                newObj["cid"] =
                                  authClients[eachc]["settings"]["cmp"][
                                    "clientId"
                                  ];
                                newObj["conid"] = authClients[eachc]["id"];
                                newObj["cname"] =
                                  authClients[eachc]["displayName"];
                                  newObj["activeLocations"] =
                                  authClients[eachc]["activeLocations"];
                                newObj["suppressionCustId"] =
                                  authClients[eachc]["suppressionCustId"];
                                dropDownObj.push(newObj);
                              }
                            }
                            localStorage.setItem(
                              "clientswitch",
                              CryptoJS.AES.encrypt(
                                JSON.stringify(dropDownObj),
                                process.env.REACT_APP_PASS
                              ).toString()
                            );
                            let authC = JSON.parse(
                              CryptoJS.AES.decrypt(
                                localStorage.getItem("groupDetails"),
                                process.env.REACT_APP_PASS
                              ).toString(CryptoJS.enc.Utf8)
                            );
                            let channelDisplayObj = {};
                            for (let m in authC) {
                              if (
                                authC[m]["settings"]["cmp"]["clientId"] ==
                                JSON.parse(
                                  CryptoJS.AES.decrypt(
                                    localStorage.getItem("clientId"),
                                    process.env.REACT_APP_PASS
                                  ).toString(CryptoJS.enc.Utf8)
                                )
                              ) {
                                /*localStorage.setItem("logoName", response[m]['logo']);
                                  localStorage.setItem("custDb", response[m]['clientDatabase'][0]['customer']);
                                  localStorage.setItem("geo_active", response[m]['geoActive']);
                                  localStorage.setItem("trans_rate", response[m]['transRate']);*/
                                for (let n in authC[m]["settings"][
                                  "channels"
                                ]) {
                                  channelDisplayObj[
                                    authC[m]["settings"]["channels"][n]["id"]
                                  ] =
                                    authC[m]["settings"]["channels"][n][
                                      "display"
                                    ];
                                }
                                if (authC[m]["activeLocations"] !== undefined) {
                                  localStorage.setItem(
                                    "numberOfActiveLocations",
                                    CryptoJS.AES.encrypt(
                                      JSON.stringify(
                                        authC[m]["activeLocations"]
                                      ),
                                      process.env.REACT_APP_PASS
                                    ).toString()
                                  );
                                } else {
                                  localStorage.setItem(
                                    "numberOfActiveLocations",
                                    CryptoJS.AES.encrypt(
                                      JSON.stringify(""),
                                      process.env.REACT_APP_PASS
                                    ).toString()
                                  );
                                }
                                if (
                                  authC[m]["suppressionCustId"] !== undefined
                                ) {
                                  localStorage.setItem(
                                    "suppressionCustId",
                                    CryptoJS.AES.encrypt(
                                      JSON.stringify(
                                        authC[m]["suppressionCustId"]
                                      ),
                                      process.env.REACT_APP_PASS
                                    ).toString()
                                  );
                                } else {
                                  localStorage.setItem(
                                    "suppressionCustId",
                                    CryptoJS.AES.encrypt(
                                      JSON.stringify(""),
                                      process.env.REACT_APP_PASS
                                    ).toString()
                                  );
                                }
                                localStorage.setItem(
                                  "channelsDisObj",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(channelDisplayObj),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                localStorage.setItem(
                                  "conceptName",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(authC[m]["name"]),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                localStorage.setItem(
                                  "channels",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(
                                      authC[m]["settings"]["channels"].map(
                                        (a) => a.id
                                      )
                                    ),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );

                                // CACHING - Client Record
                                await saveData("cmp", "cmp", "clientConfig", authC[m])

                                // CACHING - Insights
                                if(authC[m].hasOwnProperty('htmlReporting')) {
                                  if(authC[m].htmlReporting.hasOwnProperty('insights')) {
                                    window.sessionStorage.setItem('html-reporting-insights', JSON.stringify(authC[m].htmlReporting))
                                  } 
                                }
                                
                                // // POWERBI - INTEGRATION
                                // if(authC[m]["settings"]["powerBiDashboard"] !== null && authC[m]["settings"]["powerBiDashboard"] !== undefined) {
                                //   localStorage.setItem("powerBiInfo",CryptoJS.AES.encrypt(JSON.stringify(authC[m]["settings"]["powerBiDashboard"]),process.env.REACT_APP_PASS).toString());
                                //   await handlePowerBiLogin(
                                //     authC[m]["settings"]["powerBiDashboard"], 
                                //     userToken
                                //   ).then(data=>data)
                                // }
                                // else {
                                //   localStorage.removeItem("powerBiInfo");
                                // }

                                localStorage.setItem(
                                  "dappId",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(
                                      authC[m]["settings"]["qlikSense"][
                                        "dashboardAppId"
                                      ]
                                    ),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                localStorage.setItem(
                                  "dsheetId",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(
                                      authC[m]["settings"]["qlikSense"][
                                        "dashboardSheetId"
                                      ]
                                    ),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                localStorage.setItem(
                                  "globalFilter",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(
                                      "ca.geo_concept = '" +
                                        authC[m]["id"] +
                                        "'"
                                    ),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                let cName = authC[m]["parentName"];
                                let cDb = cName + "_refined";
                                localStorage.setItem(
                                  "logoName",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(cName),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                localStorage.setItem(
                                  "custDb",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(cDb),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                                localStorage.setItem(
                                  "geo_active",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify("true"),
                                    process.env.REACT_APP_PASS
                                  ).toString()
                                );
                              }
                            }
                            this.setState({ loggedIn: true });
                          })
                          .catch((error) => {
                            localStorage.clear();
                            console.log(error);
                          });
                      })
                      .catch((error) => {
                        localStorage.clear();
                        console.log(error);
                      });
                  })
                  .catch((error) => {
                    localStorage.clear();
                    console.log(error);
                  });
                // localStorage.setItem("clientId", decoded.custom:client_id);
                var obj = {
                  method: "GET",
                  headers: { Authorization: userToken },
                };

                fetch(process.env.REACT_APP_QLIK_API + "ticket", obj)
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      var qlik = result["Set-Cookie"].split("=")[1];
                      var qlikSession = qlik.split("; ")[0];
                      var currentDate = new Date();
                      currentDate.setHours(currentDate.getHours() + 1);
                      cookies.set("Qlik-Ticket-CMP", result["ticket"], {
                        path: "/",
                        expires: currentDate,
                        domain: ".cmp.io",
                      });
                      cookies.set("X-Qlik-Session-CMP", qlikSession, {
                        path: "/",
                        expires: currentDate,
                        domain: ".cmp.io",
                      });
                      localStorage.setItem("cookie", result["cookie"]);
                      localStorage.setItem("ticket", result["ticket"]);
                      localStorage.setItem("qlikExp", currentDate.getTime())
                      localStorage.setItem("cmpQlikToken", userToken) 
                      //
                      var obj = {
                        method: "GET",
                        headers: { Authorization: userToken },
                      };

                      fetch(
                        process.env.REACT_APP_QLIK_API +
                          "apps?cookie=" +
                          result["cookie"],
                        obj
                      )
                        .then((res) => res.json())
                        .then(
                          (result) => {
                            var myMap = new Object();
                            //var myMap = Object.create(null);

                            result["data"].map((list, idx) => {
                              myMap[list.id] = list.attributes.name;
                              // myMap.set(list.id, list.attributes.name);
                            });

                            //myMap["length"] = result["data"].length;
                            localStorage.setItem(
                              "appData",
                              CryptoJS.AES.encrypt(
                                JSON.stringify(myMap),
                                process.env.REACT_APP_PASS
                              ).toString()
                            );
                          },
                          (error) => {
                            localStorage.clear();
                            console.log(error);
                            this.setState({ errorMsg: "Login Failed" });
                            this.setState({ message: "Login Failed" });
                            this.setState({ color: "warning" });
                            this.showNotification("tr");
                          }
                        );
                      //
                      // window.location.reload();
                    },
                    (error) => {
                      localStorage.clear();
                      console.log(error);
                      //window.location.reload();
                      this.setState({ errorMsg: "Login Failed" });
                      this.setState({ message: "Login Failed" });
                      this.setState({ color: "warning" });
                      this.showNotification("tr");
                    }
                  );
                  
                // API call logic follows ....
                });

              //this.refreshToken();
            } else {
              localStorage.clear();
              this.setState({ errorMsg: "Login Failed" });
              this.setState({ message: "Login Failed" });
              this.setState({ color: "warning" });
              this.showNotification("tr");
              // window.location.reload();
            }
          })
          .catch((err) => {
            localStorage.clear();
            this.setState({ errorMsg: err["message"] });
            this.setState({ message: err["message"] });
            this.setState({ color: "warning" });
            this.showNotification("tr");
          });
        //setTimeout(function() {}.bind(this), 5000);
      } catch (e) {
        localStorage.clear();
        this.setState({ errorMsg: e["message"] });
        this.setState({ alertColor: "warning" });
        this.showNotification("tr");
      }
    }
  };
  async componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears

    try {
      if (await Auth.currentSession()) {
        this.setState({ loggedIn: true });
      }
    } catch (e) {
      localStorage.clear();
      if (e !== "No current user") {
      }
    }
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    if (this.state.loggedIn === true) {
      window.location.href = "/dashboard";
      //this.props.history.push("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    const { classes } = this.props;
    return (
      <React.Fragment>
        <LoadingOverlay
          style={{ height: "100%" }}
          active={this.state.isActive}
          spinner
          text="Logging in... Please Wait..."
        >
          <div className={classes.fullPage}>
            <div className={classes.container}>
              <GridItem xs={12} sm={12} md={3}>
                <Snackbar
                  place="tr"
                  color={this.state.color}
                  message={this.state.message}
                  open={this.state.tr}
                  closeNotification={() => this.setState({ tr: false })}
                  close
                />
              </GridItem>
              <GridContainer justify="center">
                <GridItem xs={12} sm={6} md={4}>
                  <form onSubmit={this.handleSubmit}>
                    <Card login className={classes[this.state.cardAnimaton]}>
                      <CardHeader
                        className={`${classes.primaryCardHeader} ${
                          classes.textCenter
                        }`}
                        color="primary"
                      >
                        <img src={cmplogo} alt="..." />
                        <h4 className={classes.cardTitle}>
                          Welcome to your Customer Management Platform
                        </h4>
                      </CardHeader>
                      <CardBody>
                        <CustomInput
                          success={this.state.registerEmailState === "success"}
                          error={this.state.registerEmailState === "error"}
                          labelText="Email *"
                          id="email"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            onChange: (event) =>
                              this.handleChange(event, "email"),
                            endAdornment: (
                              <InputAdornment position="end">
                                <Email className={classes.inputAdornmentIcon} />
                              </InputAdornment>
                            ),
                          }}
                        />
                        <CustomInput
                          success={
                            this.state.registerPasswordState === "success"
                          }
                          error={this.state.registerPasswordState === "error"}
                          id="password"
                          labelText="Password *"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            type: "password",
                            onChange: (event) =>
                              this.handleChange(event, "password"),
                            endAdornment: (
                              <InputAdornment position="end">
                                <Icon className={classes.inputAdornmentIcon}>
                                  lock_outline
                                </Icon>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <div style={{ "text-align": "right" }}>
                          {/*<a href="/register-page">Register</a>
                        <span> | </span>*/}
                          <a href="/forgot-password">Forgot your password?</a>
                        </div>
                      </CardBody>
                      <CardFooter className={classes.justifyContentCenter}>
                        <Button
                          className="btn btncreate"
                          style={{ padding: "15px 25px" }}
                          color="secondary"
                          // size="lg"
                          type="submit"
                        >
                          Login
                        </Button>
                      </CardFooter>
                    </Card>
                  </form>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </LoadingOverlay>
      </React.Fragment>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(loginPageStyle)(LoginPage);



// WEBPACK FOOTER //
// ./src/views/Pages/LoginPage.jsx